import { createContext, useContext, useEffect, useRef } from 'react'
import { useAuth } from './AuthContext'
import { initTracker, trackEvent, trackMutation, trackApiError, destroyTracker } from '../lib/activity-tracker'
import { userAPI } from '../lib/supabase'

const ActivityContext = createContext({
  trackEvent: () => {},
  trackMutation: () => {},
  trackApiError: () => {},
})

export const useActivity = () => useContext(ActivityContext)

export function ActivityProvider({ children }) {
  const { isAuthenticated } = useAuth()
  const initializedRef = useRef(false)

  useEffect(() => {
    if (isAuthenticated && !initializedRef.current) {
      initializedRef.current = true
      initTracker(async () => {
        try {
          return await userAPI.getAuthToken()
        } catch {
          return null
        }
      })
    }

    return () => {
      if (initializedRef.current) {
        destroyTracker()
        initializedRef.current = false
      }
    }
  }, [isAuthenticated])

  const value = { trackEvent, trackMutation, trackApiError }

  return (
    <ActivityContext.Provider value={value}>
      {children}
    </ActivityContext.Provider>
  )
}
